import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TestSeriesTableElement from "./TestSeriesTableElement";
import TestSeriesWhiteChipTableElement from "./TestSeriesWhiteChipTableElement";
import SubstrateSection from "../../../../../../api/models/test-series/SubstrateSection";
import SubstrateActionValueGroup from "../../../../../../api/models/test-series/SubstrateActionValueGroup";
import ActionFlow from "../../../../../../api/models/test-series/ActionFlow";
import { TestSeriesContext } from "../../../../../../contexts/TestSeriesContext";
import ActionValue from "../../../../../../api/models/test-series/ActionValue";

const useStyles = makeStyles({
  tableCell: {
    border: "1px solid",
    borderColor: "#ECECED",
    verticalAlign: "top",
  },
  cellHeadline2: {
    color: "#757575",
    fontSize: "0.9rem",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
});

interface TestSeriesSubstrateColumnProps {
  enabled: boolean;
  validated: boolean;
  substrateNumber: string;
  substrate: SubstrateSection;
  updateSubstrate: (substrate: SubstrateSection) => void;
}

const TestSeriesSubstrateColumn: React.FunctionComponent<TestSeriesSubstrateColumnProps> = (props) => {
  const { enabled, substrateNumber, substrate, updateSubstrate, validated } = props;
  const { showTextDialog } = useContext(TestSeriesContext);
  const classes = useStyles();

  function handleChangeSuffix(index: number): Promise<void> | void {
    const flowToChange = substrate.substrateActionFlows[index].actionFlow;
    if (flowToChange) {
      return showTextDialog(
        "Enter Suffix",
        flowToChange.nameSuffix,
        "Please enter a suffix to further describe the sample",
        { disabledOnEmpty: true, disabledHint: "Please enter a suffix" },
      )
        .then((nameSuffix) => {
          const newFlows = [...substrate.substrateActionFlows];
          newFlows[index].actionFlow = { ...flowToChange, nameSuffix };
          updateSubstrate({ ...substrate, substrateActionFlows: newFlows });
        })
        .catch(() => {
          // do nothing
        });
    }
  }

  function handleDeleteSubstrate(i: number): void {
    const newArray = [...substrate.substrateActionFlows];
    newArray.splice(i, 1);
    substrate.substrateActionFlows = newArray;
    // trigger rerender through state update
    updateSubstrate({ ...substrate });
  }

  return (
    <TableCell align="left" className={classes.tableCell} scope="row">
      <div className={classes.cellHeadline2}>Substrate {substrateNumber}</div>
      {substrate.substrateActionFlows &&
        substrate.substrateActionFlows
          .filter((e) => e.actionFlow)
          .map((e: SubstrateActionValueGroup, i: number) => {
            return (
              <span key={e.id || JSON.stringify(e)}>
                <TestSeriesTableElement
                  enabled={enabled}
                  validated={validated}
                  section="substrate"
                  primaryChip={(e.actionFlow as ActionFlow).name}
                  primaryChipSuffix={(e.actionFlow as ActionFlow).nameSuffix}
                  secondaryChips={(e.actionFlow as ActionFlow).actionValues}
                  onChangeSuffix={() => handleChangeSuffix(i)}
                  onPrimaryChipDelete={(): void => {
                    handleDeleteSubstrate(i);
                  }}
                  updateParentState={(): void => {
                    updateSubstrate({ ...substrate });
                  }}
                />
              </span>
            );
          })}
      <div className={classes.cellHeadline2}>Actions on all Substrates {substrateNumber}</div>
      <TestSeriesWhiteChipTableElement
        enabled={enabled}
        validated={validated}
        section="substrate"
        chips={substrate.actionsOnAllSubstrates ? substrate.actionsOnAllSubstrates.actionValues : []}
        updateParentState={(newChips): void => {
          if (!substrate.actionsOnAllSubstrates) {
            substrate.actionsOnAllSubstrates = {
              name: "",
              actionValues: newChips as ActionValue[],
            };
          }
          updateSubstrate({ ...substrate });
        }}
      />
    </TableCell>
  );
};
export default TestSeriesSubstrateColumn;
